module.exports = __webpack_public_path__ + "img/int2_cas_fet_01.c8801a88.jpg";